module.exports = __webpack_public_path__ + "img/cave25.1c769bfa.jpg";